var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { injectable, unmanaged } from 'inversify';
import FeedbackLoader from '@mail/feedback-loader/FeedbackLoader';
import EventsLogger from '@mail/feedback-loader/EventsLogger';
import merge from 'lodash/merge';
import { HttpService } from '../http';
import { Logger } from '../logger';
import { Calendar } from '../calendar';
let CsatService = class CsatService {
    constructor(url, http, logger, calendar, checkBeforeUpdate) {
        this.url = url;
        this.http = http;
        this.logger = logger;
        this.calendar = calendar;
        this.checkBeforeUpdate = checkBeforeUpdate;
        this.userId = '';
        this.activeFrom = new Date();
        this.eventsLogger = null;
        this.feedbackLoader = null;
        this.isInitialized = false;
    }
    setUser({ id, activeFrom }) {
        this.userId = id;
        if (activeFrom) {
            this.activeFrom = activeFrom;
        }
        this.init();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isInitialized) {
                this.logger.info('CSAT duplicated initialization', {
                    tags: {
                        vkdoc_error_type: 'csat',
                    },
                    context: {
                        csat_error: 'duplicated initialization',
                    },
                });
                return;
            }
            if (!this.url || !this.userId) {
                this.logger.info('CSAT cannot be initialized because there is not url or user id', {
                    tags: {
                        vkdoc_error_type: 'csat',
                    },
                    context: {
                        csat_error: 'no url or user id',
                        url: this.url,
                        userId: this.userId,
                    },
                });
                return;
            }
            try {
                const config = (yield this.http.get(this.url, undefined, {
                    withAuth: false,
                }));
                this.eventsLogger = new EventsLogger();
                this.feedbackLoader = new FeedbackLoader(config.surveys, merge(config.options || {}, {
                    checkBeforeUpdate: () => __awaiter(this, void 0, void 0, function* () {
                        if (!(config.allowedPaths || []).includes(window.location.pathname)) {
                            throw new Error('not a avalid page');
                        }
                        if (config.activeForDays &&
                            typeof config.activeForDays === 'number' &&
                            this.activeFrom < new Date() &&
                            this.calendar.differenceInCalendarDays(new Date(), this.activeFrom) < config.activeForDays) {
                            throw new Error(`user is active for less than ${this.activeFrom} days`);
                        }
                        return this.checkBeforeUpdate();
                    }),
                    surveyLoaderOptions: {
                        eventsLogger: this.eventsLogger,
                        clientId: this.userId,
                    },
                }));
                this.feedbackLoader.observe();
                this.registerEvent('action:app:opened');
                this.isInitialized = true;
            }
            catch (error) {
                this.feedbackLoader = null;
                this.eventsLogger = null;
                this.logger.error(error, {
                    tags: {
                        vkdoc_error_type: 'csat',
                    },
                    context: {
                        csat_error: error,
                    },
                });
            }
        });
    }
    stop() {
        var _a;
        (_a = this.feedbackLoader) === null || _a === void 0 ? void 0 : _a.disconnect();
        this.isInitialized = false;
    }
    registerEvent(event) {
        var _a;
        (_a = this.eventsLogger) === null || _a === void 0 ? void 0 : _a.push(event);
    }
};
CsatService = __decorate([
    injectable(),
    __param(0, unmanaged()),
    __param(1, unmanaged()),
    __param(2, unmanaged()),
    __param(3, unmanaged()),
    __param(4, unmanaged()),
    __metadata("design:paramtypes", [String, HttpService,
        Logger,
        Calendar, Function])
], CsatService);
export { CsatService };
